import {
  ADD_ITEMS,
  UPDATE_ORDER_SUMMARY,
  EMPTY_CART,
  TEMP_DOCUMENT,
  TEMP_DOCUMENT_DOCX,
  EMPTY_CART_WHITOUT_DOCUMENT,
  UPDATE_BUSINESS_COUPON,
} from './cart.types';

interface CartState {
  items: Array<any>;
  orderSummary: Object;
  tempDocument: string | null;
  tempDocumentDocx: string | null;
  businessCoupon: Object;
}

const initState: CartState = {
  items: [],
  orderSummary: {},
  tempDocument: '',
  tempDocumentDocx: '',
  businessCoupon: {},
};

const cartReducer = (state = initState, action: any) => {
  switch (action.type) {
    case ADD_ITEMS:
      return {
        ...state,
        items: action.payload,
      };
    case TEMP_DOCUMENT:
      return {
        ...state,
        tempDocument: action.payload,
      };
    case TEMP_DOCUMENT_DOCX:
      return {
        ...state,
        tempDocumentDocx: action.payload,
      };
    case UPDATE_ORDER_SUMMARY:
      return {
        ...state,
        orderSummary: action.payload,
      };
    case UPDATE_BUSINESS_COUPON:
      return {
        ...state,
        businessCoupon: action.payload,
      };
    case EMPTY_CART_WHITOUT_DOCUMENT:
      return {
        ...state,
        items: [],
        orderSummary: {},
        businessCoupon: {},
      };
    case EMPTY_CART:
      return {
        ...state,
        items: [],
        orderSummary: {},
        tempDocument: '',
        businessCoupon: {},
      };
    default:
      return state;
  }
};

export default cartReducer;
